import { useGeneralGetHook, useGetProjectInfo } from "api/hooks/allHooks";
import apiUrls from "api/urls";
import { parseJsonArray } from "utils/dataManipulation";

const readFirstScenario = (value: unknown) => {
  const scenarios = parseJsonArray(typeof value === "string" ? value : undefined);
  const scenario = scenarios[0];
  return typeof scenario === "string" && scenario.length > 0 ? scenario : undefined;
};

export const useHasLegacyCrremData = (projectId: string, enabled = true) => {
  const projectInfoQuery = useGetProjectInfo(projectId);
  const scenario = readFirstScenario(projectInfoQuery.data?.[0]?.crrem_scenario_list);
  const crremQuery = useGeneralGetHook(
    ["crrem", projectId, scenario, "emission"],
    apiUrls.modernization.crrem.list({ degree: scenario, parameter: "emission", projectId }),
    { enabled: enabled && Boolean(projectId && scenario), refetchOnMount: false, retry: false }
  );
  return {
    hasData: Array.isArray(crremQuery.data) && crremQuery.data.length > 0,
    isLoading: enabled && (projectInfoQuery.isLoading || (Boolean(scenario) && !crremQuery.isFetched)),
  };
};
